import { BRANDS } from "../data/content";

function Row({ ariaHidden }) {
  return (
    <div className="flex items-center shrink-0" aria-hidden={ariaHidden}>
      {BRANDS.map((b, i) => (
        <span key={b} className="flex items-center shrink-0">
          <span
            className={`px-8 sm:px-12 text-2xl sm:text-3xl tracking-tight whitespace-nowrap ${
              i % 2 === 0
                ? "font-semibold text-[#1d1d1f]"
                : "font-serif-editorial italic font-light text-[#1d1d1f]/70"
            }`}
          >
            {b}
          </span>
          <span className="w-1.5 h-1.5 rounded-full bg-[#d4af37]/70 shrink-0" />
        </span>
      ))}
    </div>
  );
}

export default function LogoWall() {
  return (
    <section className="py-10 sm:py-14 border-y border-[#e5e5e7] bg-white overflow-hidden" data-testid="logo-marquee">
      <p className="text-center text-xs uppercase tracking-[0.22em] font-semibold text-[#86868b] mb-8">
        Brands & clients she has built for
      </p>
      <div className="relative">
        <div className="marquee-track">
          <Row ariaHidden={false} />
          <Row ariaHidden={true} />
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 sm:w-40 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 sm:w-40 bg-gradient-to-l from-white to-transparent" />
      </div>
    </section>
  );
}
